import {CommonModule} from '@angular/common';
import {Component, HostListener, ViewEncapsulation} from '@angular/core';
import {RouterModule} from '@angular/router';
import {CommonConstants, ImagePathConstants, RoutesConstants, ImageSizeConstants} from '@coreconstant';
import {lastValueFrom} from 'rxjs';
import {SetImageDimensionsDirective} from 'src/app/core/directives/set-image-dimensions.directive';
import {RequestParamModel} from 'src/app/core/models/request-param-model';
import {FaqService} from 'src/app/core/services/api-service/faq.service';
import {ResponseHandlerService} from 'src/app/core/services/common-service/response-handler.service';
import {SeoService} from '../../core/services/common-service/seo.service';
import {SafeHtmlPipe} from 'src/app/core/pipes/safe-html.pipe';
import {MetaDataConstants} from '../../core/constants/meta-data-constants';

@Component({
    selector: 'app-venues',
    imports: [RouterModule, CommonModule, SetImageDimensionsDirective, SafeHtmlPipe],
    templateUrl: './venues.component.html',
    styleUrls: ['../vendors/vendors.component.scss', './venues.component.scss'],
    providers: [SafeHtmlPipe],
    encapsulation: ViewEncapsulation.None
})
export class VenuesComponent {
    isFooterVisible: boolean = false
    activeSection: string = 'howItWorks';
    commonConstants = CommonConstants
    routesConstants = RoutesConstants
    imagePathConstants = ImagePathConstants
    imageSizeConstants = ImageSizeConstants
    requestParamModel!: RequestParamModel;
    faqList: any;

    constructor(
        private _faqService: FaqService,
        private _seoService: SeoService,
        private _responseHandlerService: ResponseHandlerService
    ) {
        this.setMetaTags()
    }

    /**
     * Initializes the component and its dependent processes.
     */
    ngOnInit() {
        this.getFAQList()
    }

    /**
     * Sets the meta tags for the current page by creating a meta tag object and passes it to the SEO service for application.
     * @return {void} Does not return a value.
     */
    setMetaTags() {
        let metaTagObject = {
            title: MetaDataConstants.HOW_IT_WORKS_VENUE.TITLE,
            description: MetaDataConstants.HOW_IT_WORKS_VENUE.DESCRIPTION,
            ogImageUrl: MetaDataConstants.HOW_IT_WORKS_VENUE.OGIMAGEURL,
            ogWebUrl: this.routesConstants.HOW_IT_WORKS_VENUES_NAVIGATION,
        }
        this._seoService.setMetaTags(metaTagObject)
    }

    /**
     * Handles the window scroll event to determine the currently active section
     * in the viewport based on predefined section IDs.
     */
    @HostListener('window:scroll', [])
    onScroll() {
        const sections = ['howItWorks', 'whatSets', 'ourStatistics', 'successStories', 'pricing', 'faqs'];
        let currentSection = sections[0];

        for (const sectionId of sections) {
            const section = document.getElementById(sectionId);
            if (section) {
                const rect = section.getBoundingClientRect();
                if (rect.top <= window.innerHeight * 0.3 && rect.bottom >= window.innerHeight * 0.3) {
                    currentSection = sectionId;
                    break;
                }
            }
        }
        this.activeSection = currentSection;

        // If footer shows when scroll then manage the button for Mobile
        const footerSection = document.getElementById('footer-section');
        if (footerSection) {
            const rect = footerSection.getBoundingClientRect();
            this.isFooterVisible = rect.top < window.innerHeight && rect.bottom >= 0;
        }
    }

    /**
     * Scrolls smoothly to the specified section of the page based on the section ID and adjusts for header offset.
     * @param {string} sectionId - The ID of the section to scroll to.
     */
    scrollToSection(sectionId: any) {
        const section = document.getElementById(sectionId);
        const headerOffset = this.commonConstants.HEADER_OFFSET;
        if (section) {
            const elementPosition = section.getBoundingClientRect().top + window.scrollY;
            const offsetPosition = elementPosition - headerOffset;

            window.scrollTo({
                top: offsetPosition,
                behavior: 'smooth'
            });
        }
    }

    /**
     * Retrieves a list of frequently asked questions (FAQs) filtered by a specific category.
     */
    getFAQList() {
        this.requestParamModel = new RequestParamModel();
        this.requestParamModel.addDefaultFilter('faqCategoryId', this.commonConstants.VENUES_FAQ)

        let getListing = this._faqService.getFaqList(this.requestParamModel)
        lastValueFrom(getListing).then((res: any) => {
            if (res["data"]) {
                this.faqList = res["data"];
            }
        }, (error: any) => {
            this._responseHandlerService.handleAPIErrorResponse(error)
        });
    }
}
